import Vue from 'vue'
import ElementUI from 'element-ui';
import { getDicts, getLsDicts } from "@/api/system/dict/data";
import { selectDictLabel } from "@/utils/common";
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import App from './App.vue'

// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.getLsDicts = getLsDicts
Vue.prototype.selectDictLabel = selectDictLabel

Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
